module.exports = __webpack_public_path__ + "img/arrow-right-outline.a105766e.svg";